import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getImageUrl } from '../../../utils';
import NodeActivityEditor from '../../NodeActivityEditor';
import CommentsIcon from '../../../../public/assets/images/theme-2/icons/asterisk-white.svg';
import SneakPeakIcon from '../../../../public/assets/images/theme-2/icons/toolbar/visible-black.svg';
import { ViewSection, HeaderUserImage, HeaderUserName, HeaderDate, HeaderRequestFeedback, SneakPeak } from '../styles';
import { EditorHeaderRowLeft, Editor, EditorHeaderRowRight, BlogWrapper } from '../../NodeActivityEditor/styles';
import ImmersiveReaderButton from '../../ImmersiveReaderButton';

const PrivateBlogContentTeacherPanel = ({ fileService, report, student }) => {
  const [hasPeaked, setHasPeaked] = useState({});

  if (!report || report.length === 0) {
    return null;
  }

  if (!report.BlogPosts?.length) {
    return (
      <ViewSection>
        <p>
          <i>{i18n.__('logbook_no_posts')}</i>
        </p>
      </ViewSection>
    );
  }

  const { name, image, id } = student;

  const toggleReportComments = (blogId, type) => {
    document.dispatchEvent(new CustomEvent('toggleComments', { detail: { entityId: blogId, entityType: type } }));
  };

  const sneakPeak = (blogId) => {
    setHasPeaked({ ...hasPeaked, [blogId]: true });
  };

  const blogs = report.BlogPosts.map((blog) => {
    const { uuid: blogId, content, draft, type, updated_at } = blog;

    const workNotStarted = report.state === 'blank' || !content;
    const workInProgress = report.state === 'active' && draft;

    let editorContent = content;
    if (workNotStarted) {
      editorContent = i18n.__('work_not_started');
    } else if (workInProgress && !hasPeaked[blogId]) {
      editorContent = i18n.__('work_in_progress');
    }

    const headerPanel = (
      <>
        <EditorHeaderRowLeft>
          <HeaderUserImage key={id} src={getImageUrl(fileService, image, '60x60')} title={name} />
          <HeaderUserName>{name}</HeaderUserName>
          <HeaderDate>{new Date(updated_at).toLocaleDateString(baseLocale)}</HeaderDate>
        </EditorHeaderRowLeft>
        <EditorHeaderRowRight>
          <ImmersiveReaderButton />
          <HeaderRequestFeedback onClick={() => toggleReportComments(blogId, type)} src={CommentsIcon} />
        </EditorHeaderRowRight>
      </>
    );

    const editorPanel = (
      <Editor
        className="content-section"
        data-selection-entity="blogpost"
        data-selection-uuid={blogId}
        showStatusText={workNotStarted || (workInProgress && !hasPeaked[blogId])}
        dangerouslySetInnerHTML={{ __html: editorContent }}
      />
    );

    const sneakPeakPanel =
      workInProgress && !hasPeaked[blogId] ? (
        <SneakPeak onClick={() => sneakPeak(blogId)} src={SneakPeakIcon}>
          {i18n.__('sneak_peak')}
        </SneakPeak>
      ) : null;

    return (
      <BlogWrapper key={blogId}>
        <NodeActivityEditor
          type={type}
          disabled={true}
          headerPanel={headerPanel}
          editorPanel={editorPanel}
          sneakPeakPanel={sneakPeakPanel}
        />
      </BlogWrapper>
    );
  });

  return <ViewSection>{blogs}</ViewSection>;
};

export default PrivateBlogContentTeacherPanel;

PrivateBlogContentTeacherPanel.propTypes = {
  fileService: PropTypes.object.isRequired,
  report: PropTypes.object.isRequired,
  student: PropTypes.object.isRequired,
};
